var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Outlet as RawOutlet, useInRouterContext, useLocation } from 'react-router-dom';
import { isRumExcludedPath } from '../../../observability/privacyConfig';
import { FallbackComponent } from '../fallback';
var ExcludedRouteBoundary = function (_a) {
    var children = _a.children;
    var pathname = useLocation().pathname;
    if (!isRumExcludedPath(pathname))
        return _jsx(_Fragment, { children: children });
    return (_jsx("div", __assign({ "data-dd-privacy": "hidden", style: { display: 'contents' } }, { children: children })));
};
/**
 * Hides the content of RUM-excluded routes from Datadog Session Replay and click tracking. It sits inside
 * the Suspense boundary so the wrapper stays with a page React keeps mounted while the next route loads.
 */
var RumRouteBoundary = function (_a) {
    var children = _a.children;
    return useInRouterContext() ? _jsx(ExcludedRouteBoundary, { children: children }) : _jsx(_Fragment, { children: children });
};
export var Outlet = function (props) {
    return (_jsx(Suspense, __assign({ fallback: _jsx(FallbackComponent, { requesting: true }) }, { children: _jsx(RumRouteBoundary, { children: _jsx(RawOutlet, __assign({}, props)) }) })));
};
